"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPeriod = void 0;
var math_1 = require("../common/math");
var definitions_1 = require("./gamesettings/definitions");
function formatPeriod(periodNumber, periodType) {
    if (periodType === void 0) { periodType = definitions_1.PeriodType.Quarters; }
    var typeLabel;
    var displayNumber = periodNumber;
    switch (periodType) {
        case definitions_1.PeriodType.Quarters: {
            if (periodNumber <= 4) {
                typeLabel = 'Quarter';
            }
            else {
                displayNumber = periodNumber - 4;
                typeLabel = 'Overtime';
            }
            break;
        }
        case definitions_1.PeriodType.Halves: {
            if (periodNumber <= 2) {
                typeLabel = 'Half';
            }
            else {
                displayNumber = periodNumber - 2;
                typeLabel = 'Overtime';
            }
            break;
        }
        default:
            typeLabel = 'Period';
    }
    var suffix = getOrdinalSuffix(displayNumber);
    return "".concat(displayNumber).concat(suffix, " ").concat(typeLabel);
}
exports.formatPeriod = formatPeriod;
function getOrdinalSuffix(n) {
    if ((0, math_1.inRange)(n, 10, 20)) {
        return 'th';
    }
    var lastDigit = n % 10;
    switch (lastDigit) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}
//# sourceMappingURL=announcements.js.map